// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  height: 48px;
}

h6 {
  margin: 0 !important;
}

h2 {
  margin-bottom: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/withdraw/withdrawal-reverse-confirm/withdrawal-reverse-confirm.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEA;EACI,oBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ","sourcesContent":["ion-button{\r\n    height: 48px;\r\n}\r\n\r\nh6{\r\n    margin: 0!important;\r\n}\r\n\r\nh2{\r\n    margin-bottom: 0!important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
